
const getInitialState = (): HealthState => {
  return {
    healthWriteEnabled: false,
    healthReadEnabled: false,
    healthWriteAuthorized: false,
    healthReadAuthorized: false,
    healthAvailable: false,
  };
};

const health = (
  state = getInitialState(),
): HealthState => {

  return state;
};

export default health;
